module.exports = __webpack_public_path__ + "assets/projects/robots-and-ai/project-preview.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/robots-and-ai/project-preview.jpg
// module id = 15
// module chunks = 0